/* global $ */
/**
 * This interceptor add a class to the #main div corresponding to the current route
 * The main purpose is to display different background depending on current screen
 */
module.exports = [
    {
        type: "navigation", //called on navigation
        interceptor: function (app, context, next){

            if(window.IZEE_MODULES){
                app.context.controllers.mainController.view.ensureDisplayed(function(){

                    var colorByRoute = {} ;
                    var gradientByRoute = {} ;
                    var gradientMain = "main" ;
                    window.IZEE_MODULES.forEach(function(module){
                        var menu = module.computedMenu || module.menu ;
                        if(menu){
                            if(!Array.isArray(menu)){
                                menu = [menu] ;
                            }
                            menu.forEach(function(m){
                                var color = m.color ;
                                var gradient = m.gradient ;
                                if(gradient && gradient !== "main"){
                                    if(gradientMain !== "main"){
                                        //many main module, use standard owork
                                        gradientMain = "azur";
                                    }else{
                                        gradientMain = gradient ;
                                    }
                                }
                                if(m.url){
                                    var url = m.url ;
                                    if(url.indexOf("$") !== -1){
                                        url = url.substring(0, url.indexOf("$")) ;
                                    }
                                    colorByRoute[url] = color ;
                                    gradientByRoute[url] = gradient ;
                                }
                                if(m.entries){
                                    m.entries.forEach(function(e){
                                        if(e.url){
                                            var url = e.url ;
                                            if(url.indexOf("$") !== -1){
                                                url = url.substring(0, url.indexOf("$")) ;
                                            }
                                            colorByRoute[url] = color ;
                                            gradientByRoute[url] = gradient ;
                                        }
                                    }) ;
                                }
                            }) ;
                        }
                    }) ;
                    var currentRoutes = app._getRoutes(app._currentPosition()) ;
        
                    var currentColor = "yellow";
                    var currentGradient = gradientMain||"owork";
                    currentRoutes.forEach(function(r){
                        if(r.route){
                            var color = colorByRoute["#"+r.route] ;
                            if(color){
                                currentColor = color ;
                            }
                            var gradient = gradientByRoute["#"+r.route] ;
                            if(gradient){
                                currentGradient = gradient ;
                            }
                        }
                    }) ;
                    if(currentGradient === "main"){
                        if(gradientMain !== "main"){
                            currentGradient = gradientMain;
                        }else{
                            currentGradient = "owork";
                        }
                    }
    
                    document.body.className = document.body.className.replace(/ content-bg-[^\s]*/g, "");
                    document.body.className += " content-bg-"+currentColor ;
                    document.body.className = document.body.className.replace(/ content-gradient-[^\s]*/g, "");
                    document.body.className += " content-gradient-"+currentGradient ;

                    var routesElements = window.location.hash.split("#").map(function(e){
                        return "#"+e.replace(/^!/, "") ;
                    }).filter(function(r){
                        return r !== "#" ;
                    }) ;

                    $(".izee-menu-title").removeClass('active') ;

                    if(app.context.isV2){
                        var menuLinksRef = Array.prototype.slice.apply(document.querySelectorAll('.main-sidebar [data-submenu="refs"] .menu-izee-entry')) ;
                        var menuLinksFav = Array.prototype.slice.apply(document.querySelectorAll('.main-sidebar [data-submenu="fav"] .menu-izee-entry')) ;
                        let otherMenuLinks = Array.prototype.slice.apply(document.querySelectorAll('.main-sidebar .menu-izee-entry'))
                            .filter(l=>!menuLinksRef.some(m=>m===l) && !menuLinksFav.some(m=>m===l)) ;

                        let menuLinks = menuLinksRef.concat(otherMenuLinks).concat(menuLinksFav) ;

                        
                        let activeFound = false;
                        for(var i=0; i<menuLinks.length; i++){
                            var menuLink = menuLinks[i] ;
                            if(menuLink.hasAttribute("data-is-filter")){
                                continue;
                            }
                            var inRoutes = false;
                            if(menuLink.hasAttribute("data-route")){
                                var menuRoutes = menuLink.getAttribute("data-route").split("#").map(function(e){
                                    return "#"+e.replace(/^!/, "") ;
                                }).filter(function(r){
                                    return r !== "#" ;
                                }) ;
                                inRoutes = menuRoutes.every(function(menuRoute){
                                    return routesElements.indexOf(menuRoute) !== -1 ;
                                }) ;
                            }
                            if(inRoutes){
                                console.log("ACTIVE MENU IS ", menuLink.getAttribute("data-route")) ;
                                if(menuLink.className.indexOf("active") === -1){
                                    menuLink.className += " active" ;
                                }
                                if(!activeFound){
                                    activeFound = true;
                                    if(menuLink.parentElement.className.indexOf("show") === -1){
                                        $(menuLink.parentElement).collapse('show') ;
                                    }
                                    $(menuLink.parentElement.parentElement).find(".izee-menu-title").addClass('active') ;
                                }
                            }else{
                                if(menuLink.className.indexOf("active") !== -1){
                                    menuLink.className = menuLink.className.replace(" active", "") ;
                                }
                            }
                        }
                    }else{
                        var menuLinks = document.querySelectorAll(".submenu-refs .menu-izee-entry") ;
                        var foundInrefs = false ;
                        for(var i=0; i<menuLinks.length; i++){
                            var menuLink = menuLinks[i] ;
                            var inRoutes = routesElements.some(function(r){
                                return r && menuLink.hasAttribute("data-route") && 
                                    menuLink.getAttribute("data-route") === r  ;
                            }) ;
                            if(inRoutes){
                                foundInrefs = true ;
                                if(menuLink.className.indexOf("active") === -1){
                                    menuLink.className += " active" ;
                                }
                                if(menuLink.parentElement.className.indexOf("show") === -1){
                                    $(menuLink.parentElement).collapse('show') ;
                                }
                                $(menuLink.parentElement.parentElement).find(".izee-menu-title").addClass('active') ;
                            }else{
                                if(menuLink.className.indexOf("active") !== -1){
                                    menuLink.className = menuLink.className.replace(" active", "") ;
                                }
                            }
                        }
    
                        
                        menuLinks = document.querySelectorAll(".menu-izee-entry") ;
                        for(var i=0; i<menuLinks.length; i++){
                            var menuLink = menuLinks[i] ;
                            var inRoutes = routesElements.some(function(r){
                                return r && menuLink.hasAttribute("data-route") && 
                                    menuLink.getAttribute("data-route") === r  ;
                            }) ;
                            if(inRoutes){
                                if(menuLink.className.indexOf("active") === -1){
                                    menuLink.className += " active" ;
                                }
                                if(!foundInrefs){
                                    if(menuLink.parentElement.className.indexOf("show") === -1){
                                        $(menuLink.parentElement).collapse('show') ;
                                    }
                                    $(menuLink.parentElement.parentElement).find(".izee-menu-title").addClass('active') ;
                                }
                            }else{
                                if(menuLink.className.indexOf("active") !== -1){
                                    menuLink.className = menuLink.className.replace(" active", "") ;
                                }
                            }
                        }
                    }

                    //Top-level menu entries with only a url (no sub-entries, e.g. dashboard-invoicing)
                    //aren't covered by the .menu-izee-entry loops above, which only flag parents via
                    //a matching sub-entry. We match their data-route directly and add 'active' on the title.
                    var topLevelEntries = document.querySelectorAll('.main-sidebar ul.menu-content > li[data-route]') ;
                    for(var k=0; k<topLevelEntries.length; k++){
                        var topEntry = topLevelEntries[k] ;
                        var topMenuRoutes = topEntry.getAttribute("data-route").split("#").map(function(e){
                            return "#"+e.replace(/^!/, "") ;
                        }).filter(function(r){ return r !== "#" ; }) ;
                        var topInRoutes = topMenuRoutes.every(function(r){
                            return routesElements.indexOf(r) !== -1 ;
                        }) ;
                        var topTitle = topEntry.querySelector(".izee-menu-title") ;
                        if(topTitle && topInRoutes && topTitle.className.indexOf("active") === -1){
                            topTitle.className += " active" ;
                        }
                    }
                }) ;
            }

            next() ;
        }
    }
];